module.exports = __webpack_public_path__ + "img/three.06695bac.png";